export const sticky = ['$window', ($window) => {
  return {
    link(scope, elem, attrs) {
      // wrapper element
      const stickywrap = document.createElement("div")
      stickywrap.classList.add('js-Sticky-wrap')
      elem[0].parentNode.replaceChild(stickywrap, elem[0])
      stickywrap.appendChild(elem[0])
      attrs.stickyTopOffset = attrs.stickyTopOffset || 0
      attrs.stickyBottomOffset = attrs.stickyBottomOffset || 0

      const stickyClass = 'js-Sticky'
      const stickTo = document.querySelector(attrs.stickTo) || void 0
      // const stickToBottom = document.querySelector(attrs.stickToBottom) || void 0
      const getBottom = (el) => el.getBoundingClientRect().bottom
      const getTop = (el) => el.getBoundingClientRect().top
      const getHeight = (el) => el.getBoundingClientRect().height
      const getWidth = (el) => el.getBoundingClientRect().width
      const isTouching = (elem, stickTo) => {
        const elTop = elem.previousElementSibling ? getBottom(elem.previousElementSibling) : getTop(elem.parentNode)
        return elTop < ((stickTo ? getBottom(stickTo) : 0) + Number(attrs.stickyTopOffset))
      }
      // const isTouchingBottom = (elem, stickToBottom) => {
      //   const elBottom = elem.previousElementSibling ? getTop(elem.previousElementSibling) : getBottom(elem)
      //   return elBottom > ((stickToBottom ? getTop(stickToBottom) : 0) + Number(attrs.stickyBottomOffset))
      // }
      const stick = (elem, stickTo) => {
        if (!angular.element(elem).hasClass(stickyClass)) {
          if (attrs.stickAlways) {
            angular.element(stickywrap).css('height', 54)
          } else {
            const elHeight = getHeight(elem)
            const elWidth = getWidth(elem)
            angular.element(stickywrap).css('height', elHeight).css('width', elWidth)
          }
          angular.element(elem).addClass(stickyClass)
          angular.element(elem).css('top', (stickTo ? getBottom(stickTo) : 0) + Number(attrs.stickyTopOffset) + 'px')
          angular.element(elem).css('bottom', 'auto')
        }
      }
      // const stickBottom = (elem, stickToBottom) => {
      //   if (!angular.element(elem).hasClass('js-sticky-bottom')) {

      //   }
      // }
      const unstick = (elem, stickTo) => {
        angular.element(elem).removeClass(stickyClass)
        angular.element(elem).removeAttr('style');
        angular.element(stickywrap).removeAttr('style');  
      }
      const addStickTo = (stickTo) => (elem) => {
        let condition = (attrs.stickAlways || isTouching(elem, stickTo)) ? stick(elem, stickTo) : unstick(elem, stickTo)
        // condition = isTouchingBottom(elem, stickToBottom) ? stickBottom(elem, stickToBottom) : condition
        return condition
      }
      const sticky = addStickTo(stickTo)

      sticky(elem[0])
      angular.element(document).bind('scroll', () => {
        sticky(elem[0])
      })
    }
  }  
}]